/**
 * <SelectClassTeacher 
 *	/>
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import SelectClassTeacherModal from 'template/Modals/SelectClassTeacher';
import './SelectItems.scss';
import parseJson from '../parseJson';
import Teacher from 'mediators/Teacher';

import { ITEM_NAME_LIST_LENGTH } from '../constants';

//
// for ui:widget
//
export function selectClassTeacher(props) {
  const {
    mixin,
  } = props.schema;

  let value = parseJson(props.value);
  return (
    <SelectClassTeacher 
       {...props} 
       mixin={mixin} 
       value={value} 
       onChange={(data)=>{ props.onChange(JSON.stringify(data)); }} />
    );  
}

class SelectClassTeacher extends React.Component {
  static propTypes = {

  }

  static defaultProps = {
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);

    this.state = {
      teacherNames: [],
      teacherIds: [],
      selected: this.convertToMediator(props.value || []),
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        selected: this.convertToMediator(nextProps.value), 
      });
    }
  }
  
  convertToMediator(value) {
    
    return value.map((raw)=>{
      return new Teacher(raw);
    });
  }

  convertToObject(value) {
    return value.map((prox)=>{
      return prox.toObject();
    });
  }

  onChange() {
    let {
      options,
      onChange,
      selectFilter,
    } = this.props;

    let {
      conflictedIDs,
      selectMultiple,
    } = options;

    let schoolId = localStorage.getItem('schoolId');

    let {
      selected,
    } = this.state;

    SelectClassTeacherModal({ 
      conflictedIDs,
      schoolId,
      selectMultiple,
      selected,
    })
      .then((selectedOut)=>{
        let teacherNames = [];
        let teacherIds = [];
        let selected = [];

        if (!Array.isArray(selectedOut)) {
          selected = [this.convertToObject(selectedOut)];
        } else {
          selected = this.convertToObject(selectedOut);
        } 

        selected.map((teacher)=>{
          teacherNames.push(teacher.stName);
          teacherIds.push(teacher.id);
        });

        this.setState({
          teacherNames,
          teacherIds,
          selected,
        });

        onChange(selected);
      })
      .catch((err)=>{
        console.error(err); 
      });
  }

  render() {
    let {
      selected,
    } = this.state;

    let {
      disableSelect,
    } = this.props.options;

    let teacherNames = selected.map((teacher)=> {
      return teacher.name || teacher.tName;
    });

    let teacherNamesText = teacherNames.length > 0 ? teacherNames.join(', ') : <span className='no-items'>{__('Not Assigned', 'classdetail')}</span>

    return (
      <div className='select-items-button'>
        <div className='item-names'>
          {teacherNamesText}
        </div>
        { disableSelect !== true && <a className='select-button' onClick={this.onChange} >{__('Select', 'class')}</a> }
      </div>
    )
  }
}

export default SelectClassTeacher;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SelectClassTeacher.js